import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  return <p className={`inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wide text-zinc-400 ${className}`} aria-live="off" data-id="element-22" data-mp="3q1nj9y823tdn">
      <ClockIcon className="h-4 w-4 text-red-500" aria-hidden="true" data-id="element-23" data-mp="3c0b5ntgdc3ux" />
      Oferta válida por las próximas
      <span className="font-semibold tabular-nums text-amber-400" data-id="element-24" data-mp="3h2a8n2874yrc">
        {hours}:{minutes}:{seconds}
      </span>
    </p>;
}